import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BRAIN_SIMULATION_TIME_BUDGET } from '@wix/ai-scheduling-assistant-constants';
import { brainSimulationApiToBrainSimulationEntity } from '../../entities/BrainSimulation/converters';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class BrainSimulationClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getBrainSimulationImpl", void 0);
    _defineProperty(this, "deleteBrainSimulationImpl", void 0);
    _defineProperty(this, "queryBrainSimulationsImpl", void 0);
    _defineProperty(this, "exportBrainSimulationConversationsToDatasetsImpl", void 0);
    _defineProperty(this, "runSimulationFromPresetImpl", void 0);
  }
  getServiceNameForLogs() {
    return 'BrainSimulationClient';
  }
  async getBrainSimulation(brainSimulationId) {
    try {
      for (var _len = arguments.length, extraParam = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        extraParam[_key - 1] = arguments[_key];
      }
      const {
        brainSimulation
      } = await this.request(this.getBrainSimulationImpl({
        brainSimulationId
      }), ...extraParam);
      if (!brainSimulation) {
        throw new Error('Brain simulation not found');
      }
      return this.convertToEntity(brainSimulation);
    } catch (error) {
      this.logError('getBrainSimulation', 'Failed to get brain simulation', {
        brainSimulationId
      }, error);
      throw error;
    }
  }
  async deleteBrainSimulation(brainSimulationId) {
    try {
      for (var _len2 = arguments.length, extraParam = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        extraParam[_key2 - 1] = arguments[_key2];
      }
      await this.request(this.deleteBrainSimulationImpl({
        brainSimulationId
      }), ...extraParam);
    } catch (error) {
      this.logError('deleteBrainSimulation', 'Failed to delete brain simulation', {
        brainSimulationId
      }, error);
      throw error;
    }
  }
  async queryBrainSimulations(query) {
    try {
      for (var _len3 = arguments.length, extraParam = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        extraParam[_key3 - 1] = arguments[_key3];
      }
      const {
        brainSimulations,
        pagingMetadata
      } = await this.request(this.queryBrainSimulationsImpl({
        query
      }), ...extraParam);
      if (!brainSimulations) {
        throw new Error('Received invalid brain simulations');
      }
      return {
        items: brainSimulations.map(this.convertToEntity),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryBrainSimulations', 'Failed to query brain simulations', {
        query
      }, error);
      throw error;
    }
  }
  async exportBrainSimulationConversationsToDatasets(brainSimulationId) {
    try {
      this.logInfo('exportBrainSimulationConversationsToDatasets', 'entry', {
        brainSimulationId
      });
      for (var _len4 = arguments.length, extraParam = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        extraParam[_key4 - 1] = arguments[_key4];
      }
      const response = await this.request(this.exportBrainSimulationConversationsToDatasetsImpl({
        brainSimulationId
      }), ...extraParam);
      this.logInfo('exportBrainSimulationConversationsToDatasets', 'success', {
        brainSimulationId
      });
      return response;
    } catch (error) {
      this.logError('exportBrainSimulationConversationsToDatasets', 'Failed to export brain simulation conversations to datasets', {
        brainSimulationId
      }, error);
      throw error;
    }
  }
  async runSimulationFromPreset(simulationPresetId, nameOverride) {
    try {
      this.logInfo('runSimulationFromPreset', 'entry', {
        simulationPresetId,
        nameOverride
      });
      const request = this.runSimulationFromPresetImpl({
        simulationPresetId,
        nameOverride: nameOverride ?? undefined
      });
      const requestWithHeaders = context => {
        const options = typeof request === 'function' ? request(context) : request;
        return {
          ...options,
          headers: {
            ...(options.headers || {}),
            'X-Time-Budget': `${BRAIN_SIMULATION_TIME_BUDGET}`
          }
        };
      };
      for (var _len5 = arguments.length, extraParam = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        extraParam[_key5 - 2] = arguments[_key5];
      }
      const {
        brainSimulation
      } = await this.request(requestWithHeaders, ...extraParam);
      if (!brainSimulation) {
        throw new Error('Invalid brain simulation response from preset');
      }
      this.logInfo('runSimulationFromPreset', 'success', {
        simulationPresetId,
        brainSimulationId: brainSimulation.id
      });
      return this.convertToEntity(brainSimulation);
    } catch (error) {
      this.logError('runSimulationFromPreset', 'Failed to run simulation from preset', {
        simulationPresetId,
        nameOverride
      }, error);
      throw error;
    }
  }
  convertToEntity(brainSimulationApi) {
    return brainSimulationApiToBrainSimulationEntity(brainSimulationApi);
  }
}
//# sourceMappingURL=BrainSimulationClientBase.js.map